import {theme} from "Theme";

import {SubPageMenuHeaderItem} from "base/ui/menu";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

const SubPageMenuHeader = ({
    headerText = "",
    headerSecondary = "",
    headerTitle = "",
    headerTag = null,
    headerIcon = null,
    children,
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                mb: 1,
            }}
        >
            <SubPageMenuHeaderItem
                primary={headerText}
                secondary={headerSecondary}
                title={headerTitle}
                tag={headerTag}
                icon={headerIcon}
            />
            <Box sx={{bgcolor: theme.palette.menu.secondary.header.background}}>
                {children}
            </Box>
        </Paper>
    );
};

export default SubPageMenuHeader;
